import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatColors } from '../../shared/mat-colors';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NkPipesModule } from '../../pipes/pipes.module';

enum ViewType {
  PALETTES = 'palettes',
  HUES = 'hues',
}

@Component({
  selector: 'app-material-color-picker',
  templateUrl: './material-color-picker.component.html',
  styleUrls: ['./material-color-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatRippleModule,
    NkPipesModule,
    MatIconModule
  ]
})
export class MaterialColorPickerComponent {
  colors = MatColors.getAll();

  selectedColor: any;
  view = ViewType.PALETTES;
objectKeys = Object.keys;
  selectedPalette = '';
  selectedHue = '';
  selectedFg = '';
constructor() {
  this.colors = MatColors.getAll();

  if (!this.colors || Object.keys(this.colors).length === 0) {
    console.warn('[MaterialColorPickerComponent] MatColors returned no values.');
  } 
}
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output() selectedClassChange = new EventEmitter<string>();

  private _selectedClass = 'mat-red-500-bg';
  @Input()
  set selectedClass(value: string) {
    if (this._selectedClass !== value) {
      const match = (value || '').toString().match(/^mat-([-\D]+)(?:-(A?\d+))?-bg$/);
      if (match) {
        const [palette, hue = '500'] = match.slice(1);
        this.selectedPalette = this.colors[palette] ? palette : 'red';
        this.selectedHue = this.colors[this.selectedPalette][hue] ? hue : '500';
        this._selectedClass = `mat-${this.selectedPalette}-${this.selectedHue}-bg`;
      } else {
        this.resetSelection();
      }
    }
  }
  get selectedClass(): string {
    return this._selectedClass;
  }

  private _selectedBg = 'red';
  @Input()
  set selectedBg(value: string) {
    if (value && value !== '' && this._selectedBg !== value) {
      for (const palette of Object.keys(this.colors)) {
        for (const hue of Object.keys(this.colors[palette])) {
          if (this.colors[palette][hue][0] === value) {
            this.selectedPalette = palette;
            this.selectedHue = hue;
            this._selectedBg = value;
            this._selectedClass = `mat-${palette}-${hue}-bg`;
            return;
          }
        }
      }
    } else {
      this.resetSelection();
    }
  }
  get selectedBg(): string {
    return this._selectedBg;
  }

  selectPalette(palette: string) {
    this.selectedPalette = palette;
    this.selectedHue = '';
    this.view = ViewType.HUES;
  }

  selectHue(hue: string) {
    this.selectedHue = hue;
    this.updateSelectedColor();
  }

  removeColor() {
    this.selectedPalette = '';
    this.selectedHue = '';
    this.view = ViewType.PALETTES;
  }

  backToPaletteSelection() {
    this.view = ViewType.PALETTES;
  }

  async onMenuOpen() {
    this.view = this.selectedPalette ? ViewType.HUES : ViewType.PALETTES;
  }

  getHueFromPalette(palette: string): string[] {
    return Object.keys(this.colors[palette]).sort((a, b) => +a - +b);
  }

  private updateSelectedColor() {
    setTimeout(() => {
      if (
        this.selectedColor?.palette === this.selectedPalette &&
        this.selectedColor?.hue === this.selectedHue
      ) {
        return;
      }

      if (this.selectedPalette && this.selectedHue) {
        const color = this.colors[this.selectedPalette][this.selectedHue];
        [this._selectedBg, this.selectedFg] = color;
        this._selectedClass = `mat-${this.selectedPalette}-${this.selectedHue}-bg`;
      } else {
        this._selectedBg = '';
        this.selectedFg = '';
      }

      this.selectedColor = {
        palette: this.selectedPalette,
        hue: this.selectedHue,
        class: this.selectedClass,
        bg: this.selectedBg,
        fg: this.selectedFg,
      };

      this.selectedClassChange.emit(this.selectedClass);
      this.value = this.selectedColor;
      this.valueChange.emit(this.selectedColor);
    });
  }

  private resetSelection() {
    this.selectedPalette = 'red';
    this.selectedHue = '500';
    this._selectedClass = 'mat-red-500-bg';
    this._selectedBg = 'red';
    this.selectedFg = '';
  }
}
